import { useParams } from "react-router-dom";
import { useMutation } from "react-query";
import { axios } from "../lib/request";

/**
 * A React Query mutation hook for processing donation payments.
 * Sends a PATCH request to the backend with the Stripe token and donation details.
 * 
 * @returns {Object} An object containing the mutation state (`isPaying`, `error`, `data`) and the `pay` function.
 */
export const useDonationPayMutation = () => {
    const { game_id } = useParams();
    const { isLoading, mutateAsync, error, data } = useMutation(
        (params) =>
            axios.patch(
                `${process.env.REACT_APP_API_DONATE_URL}/${game_id}/donations.json`,
                params
            ),
        {
            onError: (error) => console.log("[error]", error),
        }
    );

    return { isPaying: isLoading, pay: mutateAsync, error, data };
};